import type { BaseKeyFunction } from "../../../lib";

export type KeyCollectionProps = { id: number };

export const keyCollection: BaseKeyFunction<KeyCollectionProps> = ({ id }) => [
  "collection",
  id?.toString(),
];
